import { render, staticRenderFns } from "./BedOldSetting.vue?vue&type=template&id=8662ba9a&scoped=true"
import script from "./BedOldSetting.vue?vue&type=script&lang=js"
export * from "./BedOldSetting.vue?vue&type=script&lang=js"
import style0 from "./BedOldSetting.vue?vue&type=style&index=0&id=8662ba9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8662ba9a",
  null
  
)

export default component.exports